const base64ToArrayBuffer = (b64: string): ArrayBuffer => {
  const bin = atob(b64);
  const len = bin.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i);
  return bytes.buffer;
}

const decodeBase64ToAudioBuffer = (
  audioCtx: AudioContext,
  base64Data: string
): Promise<AudioBuffer> => {
  return new Promise((resolve, reject) => {
    const arr = base64ToArrayBuffer(base64Data);
    audioCtx.decodeAudioData(arr.slice(0), resolve, reject);
  });
}

export { decodeBase64ToAudioBuffer }
